import desktop_background_night from 'art/desktop_background_night.png';
import styled from 'styled-components';

export const BackgroundDark = styled.img.attrs(() => ({
  src: desktop_background_night,
  alt: 'Cross-hatched black background',
}))`
  top: 0;
  height: auto;
  width: 100%;
  z-index: -2;
  position: fixed;
  height: auto;
  opacity: ${({ active }) => (active ? 1 : 0)};
  pointer-events: none;
`;
export default BackgroundDark;
